import React from 'react';

import { observer } from 'mobx-react';

import { Tooltip } from '@material-ui/core';

import withDisplayName from 'bz-utilities/hoc/display-name';
import useComputed from 'bz-utilities/hooks/computed';

import { useAuthStore } from 'connect/web/src/stores/auth-store';
import { useHistoryStore } from 'connect/web/src/stores/history-store';
import { useSearchStore } from 'connect/web/src/stores/search-store';

import NavButton from '../nav-button';

interface IProps {}

const NavAuthenticted = observer(
  withDisplayName<IProps>(() => {
    const authStore = useAuthStore();
    const { currentPath } = useHistoryStore();
    const { isCaseflow } = useSearchStore();

    const tooltipText = useComputed((): string => {
      const { email } = authStore;
      return `You are logged in as ${email}`;
    }, [authStore]);

    return (
      <>
        {isCaseflow && <NavButton tabIndex={5} text="My Cases" path="/cases" />}
        <NavButton tabIndex={6} text="My Diary" path="/diary" />
        <Tooltip title={tooltipText}>
          <NavButton tabIndex={7} text="My Account" currentPath={currentPath} path="/myaccount" />
        </Tooltip>
        <NavButton tabIndex={8} text="Log Out" path="/logout" />
      </>
    );
  }, 'NavAuthenticted')
);

export default NavAuthenticted;
